import React from 'react';

import { cssMap } from '@atlaskit/css';
import { SmartCardProvider } from '@atlaskit/link-provider';
import { Inline } from '@atlaskit/primitives/compiled';
import { ReactRenderer } from '@atlaskit/renderer';
import { token } from '@atlaskit/tokens';
import { encodeAdf } from '@atlassian/conversation-assistant-content-transformer/adf-encoder';

const styles = cssMap({
	container: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.050'),
	},
});

export const SummaryField = ({ summary }: { summary?: string }): React.JSX.Element | null => {
	if (!summary) {
		return null;
	}
	return (
		<Inline xcss={styles.container} testId="project-status-update-action-renderer.ui.summary">
			<SmartCardProvider>
				<ReactRenderer document={encodeAdf(summary)} />
			</SmartCardProvider>
		</Inline>
	);
};
